"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.KansaResultContainer = void 0;
var _CallAPI = require("01_core/components/system/CallAPI");
var _CustomRouter = require("01_core/components/system/CustomRouter");
var _APIs = require("01_core/constants/APIs");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _authorityUtil = _interopRequireDefault(require("01_core/logics/authorityUtil"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _KansaUnavailability = _interopRequireDefault(require("../common/components/layout/KansaUnavailability"));
var _KansaResultReferContainer = _interopRequireDefault(require("../kansaResultRefer/KansaResultReferContainer"));
var _KansaResultReferOldContainer = _interopRequireDefault(require("../kansaResultRefer/KansaResultReferOldContainer"));
var _KansaResultRegisterContainer = _interopRequireDefault(require("../kansaResultRegister/KansaResultRegisterContainer"));
var _kansaProgressActions = require("../progress/kansaProgressActions");
var _KansaResultMain = _interopRequireDefault(require("./KansaResultMain"));
var _HikansabumonChiefHyokaDetail = _interopRequireDefault(require("./hikansabumonChiefHyoka/HikansabumonChiefHyokaDetail"));
var _HikansabumonChiefHyokaRegisterEntry = _interopRequireDefault(require("./hikansabumonChiefHyoka/HikansabumonChiefHyokaRegisterEntry"));
var _HikansabumonChiefHyokaResult = _interopRequireDefault(require("./hikansabumonChiefHyoka/HikansabumonChiefHyokaResult"));
var _kansaResultActions = require("./kansaResultActions");
var _OldShitekiKaizenplanJissekiDisplay = _interopRequireDefault(require("./shitekiKaizenplanJisseki/OldShitekiKaizenplanJissekiDisplay"));
var _ShitekiKaizenplanJissekiDisplay = _interopRequireDefault(require("./shitekiKaizenplanJisseki/ShitekiKaizenplanJissekiDisplay"));
var _ShitekiKaizenplanJissekiEntry = _interopRequireDefault(require("./shitekiKaizenplanJisseki/ShitekiKaizenplanJissekiEntry"));
var _ShitekiKaizenplanJissekiEntryResult = _interopRequireDefault(require("./shitekiKaizenplanJisseki/ShitekiKaizenplanJissekiEntryResult"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * 監査結果機能コンテナ
 */
class KansaResultContainer extends _react.default.Component {
  constructor(props) {
    super(props);
    const {
      changeSearchCondition,
      progessToDispContent,
      progessToKansaInfo,
      setKansaInfo,
      isNewWindow,
      keyDispContent,
      keyKansaTgtNendo,
      keyKansaTgtJigyoId
    } = props;

    // 別ウィンドウ用コンポーネント（isNewWindowがtrueの場合）を経由している場合、
    // propsに設定されたパラメータを設定する
    if (isNewWindow) {
      // 子画面への遷移の場合、propsから値を取得
      let kansaInfo = {
        kansaTgtNendo: keyKansaTgtNendo,
        kansaTgtJigyoId: keyKansaTgtJigyoId
      };
      setKansaInfo(kansaInfo, keyDispContent, false);
    } else {
      if (progessToDispContent !== undefined) {
        // 監査進捗状況からの画面遷移の場合
        switch (progessToDispContent) {
          case _kansaResultActions.CONTENTS.PROGRESS_TO_RESULT_REFER:
            // 監査結果表示
            setKansaInfo(progessToKansaInfo, _kansaResultActions.CONTENTS.RESULT_REFER, true);
            break;
          case _kansaResultActions.CONTENTS.PROGRESS_TO_RESULT_REFER_OLD:
            // 監査結果表示（詳細版）
            setKansaInfo(progessToKansaInfo, _kansaResultActions.CONTENTS.RESULT_REFER_OLD, true);
            break;
          case _kansaResultActions.CONTENTS.PROGRESS_TO_RESULT_REGISTER:
            // 監査結果登録
            setKansaInfo(progessToKansaInfo, _kansaResultActions.CONTENTS.RESULT_REGISTER, true);
            break;
          case _kansaResultActions.CONTENTS.PROGRESS_TO_RESULT_UPDATE:
            // 監査結果更新
            setKansaInfo(progessToKansaInfo, _kansaResultActions.CONTENTS.RESULT_UPDATE, true);
            break;
          case _kansaResultActions.CONTENTS.PROGRESS_TO_SHITEKI_REFER:
            // 指摘事項改善・実績表示
            setKansaInfo(progessToKansaInfo, _kansaResultActions.CONTENTS.SHITEKI_DETAIL, true);
            break;
          case _kansaResultActions.CONTENTS.PROGRESS_TO_SHITEKI_REFER_OLD:
            // 指摘事項改善・実績表示（詳細版）
            setKansaInfo(progessToKansaInfo, _kansaResultActions.CONTENTS.SHITEKI_OLD_DETAIL, true);
            break;
          case _kansaResultActions.CONTENTS.PROGRESS_TO_SHITEKI_REGISTER:
            // 指摘事項改善・実績登録
            setKansaInfo(progessToKansaInfo, _kansaResultActions.CONTENTS.SHITEKI_ENTRY, true);
            break;
          case _kansaResultActions.CONTENTS.PROGRESS_TO_HYOKA_REFER:
            // 監査進捗状況：被監査部門責任者評価表示
            setKansaInfo(progessToKansaInfo, _kansaResultActions.CONTENTS.HIKANSA_DETAIL, true);
            break;
          case _kansaResultActions.CONTENTS.PROGRESS_TO_HYOKA_REGISTER:
            // 監査進捗状況：被監査部門責任者評価登録
            setKansaInfo(progessToKansaInfo, _kansaResultActions.CONTENTS.HIKANSA_ENTRY, true);
            break;
          default:
            break;
        }
      }
    }

    // 機能利用可否判定
    this.state = {
      avail: true
    };

    // 担当の監査対象事業のみ表示の初期値
    // 対策本部権限の場合ON
    const tantoOnlyFlg = !_authorityUtil.default.hasPermission(this.props.pms, _CodeConsts.CODE.KANSA_USAGE.CODE_ALLUSEPERMISSION) && !_authorityUtil.default.hasPermission(this.props.pms, _CodeConsts.CODE.KANSA_USAGE.CODE_LIMITEDUSEPERMISSION) ? true : false;
    changeSearchCondition('tantoOnlyFlg', tantoOnlyFlg);
  }
  componentDidMount() {
    const {
      changeSearchCondition
    } = this.props;
    this.props.callAPI(_APIs.KANSA_AVAILABILITY).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        // 機能利用可否判定結果を保持
        this.setState({
          avail: response.data.availability
        });
        changeSearchCondition('gyomuCdAvail', response.data.gyomuCd);

        // 担当する業務内容の初期値を設定
        if (response.data.gyomuCd === _CodeConsts.CODE.KANSA_GYOMU_CD.CODE_1 || response.data.gyomuCd === _CodeConsts.CODE.KANSA_GYOMU_CD.CODE_2) {
          changeSearchCondition('gyomuCd', response.data.gyomuCd);
        }
      }
    }).catch(e => {
      if ((e === null || e === void 0 ? void 0 : e.reason) === _CallAPI.CALLAPI_REJECT_REASON.UNMOUNTED || (e === null || e === void 0 ? void 0 : e.reason) === _CallAPI.CALLAPI_REJECT_REASON.CALLING) {
        return;
      }
      throw e;
    });
  }
  componentWillUnmount() {
    this.props.clear();
  }
  render() {
    const {
      intl,
      dispContent,
      kansaInfo,
      goMain,
      checkDirty,
      progessToBtnProps,
      isNewWindow,
      goProgressMain
    } = this.props;
    let transitionProps = {
      kansaInfo
    };

    // 機能利用不可の場合は機能利用不可画面を表示する
    if (!this.state.avail) {
      return /*#__PURE__*/_react.default.createElement(_KansaUnavailability.default, {
        titleLabelId: _labelConsts.LABEL.KANSA_RESULT_TITLE
      });
    }
    if (isNewWindow) {
      // 別ウィンドウで開かれた場合
      transitionProps['btnProps'] = {
        label: intl.formatMessage({
          id: _labelConsts.LABEL.CORE_CLOSE
        }),
        onClick: () => window.close()
      };
    } else if (progessToBtnProps === undefined) {
      transitionProps['btnProps'] = {
        label: intl.formatMessage({
          id: _labelConsts.LABEL.CORE_TO_RETURN_SEARCH_LIST
        }),
        onClick: function () {
          let search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
          return () => checkDirty(() => goMain(search));
        }
      };
    } else {
      // 監査進捗状況からの画面遷移の場合
      transitionProps['btnProps'] = {
        label: progessToBtnProps.label,
        onClick: function () {
          let search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
          return () => checkDirty(() => goProgressMain(search));
        }
      };
    }
    switch (dispContent) {
      case _kansaResultActions.CONTENTS.MAIN:
        return /*#__PURE__*/_react.default.createElement(_KansaResultMain.default, null);
      case _kansaResultActions.CONTENTS.RESULT_REFER:
        return /*#__PURE__*/_react.default.createElement(_KansaResultReferContainer.default, _extends({}, transitionProps, {
          isNewWindow: isNewWindow
        }));
      case _kansaResultActions.CONTENTS.RESULT_REFER_OLD:
        return /*#__PURE__*/_react.default.createElement(_KansaResultReferOldContainer.default, _extends({}, transitionProps, {
          isNewWindow: isNewWindow
        }));
      case _kansaResultActions.CONTENTS.RESULT_REGISTER:
        return /*#__PURE__*/_react.default.createElement(_KansaResultRegisterContainer.default, transitionProps);
      case _kansaResultActions.CONTENTS.RESULT_UPDATE:
        return /*#__PURE__*/_react.default.createElement(_KansaResultRegisterContainer.default, _extends({}, transitionProps, {
          upd: true
        }));
      case _kansaResultActions.CONTENTS.SHITEKI_DETAIL:
        return /*#__PURE__*/_react.default.createElement(_ShitekiKaizenplanJissekiDisplay.default, _extends({}, transitionProps, {
          isNewWindow: isNewWindow
        }));
      case _kansaResultActions.CONTENTS.SHITEKI_OLD_DETAIL:
        return /*#__PURE__*/_react.default.createElement(_OldShitekiKaizenplanJissekiDisplay.default, _extends({}, transitionProps, {
          isNewWindow: isNewWindow
        }));
      case _kansaResultActions.CONTENTS.SHITEKI_ENTRY:
        return /*#__PURE__*/_react.default.createElement(_ShitekiKaizenplanJissekiEntry.default, transitionProps);
      case _kansaResultActions.CONTENTS.HIKANSA_RESULT:
        return /*#__PURE__*/_react.default.createElement(_HikansabumonChiefHyokaResult.default, transitionProps);
      case _kansaResultActions.CONTENTS.HIKANSA_DETAIL:
        return /*#__PURE__*/_react.default.createElement(_HikansabumonChiefHyokaDetail.default, transitionProps);
      case _kansaResultActions.CONTENTS.HIKANSA_ENTRY:
        return /*#__PURE__*/_react.default.createElement(_HikansabumonChiefHyokaRegisterEntry.default, transitionProps);
      case _kansaResultActions.CONTENTS.SHITEKI_RESULT:
        return /*#__PURE__*/_react.default.createElement(_ShitekiKaizenplanJissekiEntryResult.default, transitionProps);
      default:
        return /*#__PURE__*/_react.default.createElement(_KansaResultMain.default, null);
    }
  }
}
exports.KansaResultContainer = KansaResultContainer;
KansaResultContainer.propTypes = {
  goProgress: _propTypes.default.func
};
const mapStateToProps = state => {
  return {
    dispContent: state.kansaResult.dispContent,
    kansaInfo: state.kansaResult.kansaInfo,
    shareCondition: state.kansaShareCondition
  };
};
const mapDispatchToProps = dispatch => {
  return {
    changeSearchCondition: (key, value) => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.CHANGE_SEARCH_CONDITION](key, value)),
    setKansaInfo: (kansaInfo, dispContent, isProgress) => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.SET_KANSA_INFO](kansaInfo, dispContent, isProgress)),
    clear: () => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.CLEAR]()),
    goMain: search => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.GO_MAIN](search)),
    goProgressMain: search => dispatch(_kansaProgressActions.kansaProgressActions[_kansaProgressActions.TYPES.GO_MAIN](search))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CustomRouter.withRouter)((0, _CallAPI.withCallAPI)(KansaResultContainer))));